export default {"src":"/_next/static/image/public/images/ic_upload_thanks_homecare.8853c64fedb3ec65d45bbfa5291e60ff.svg","height":137,"width":104};